import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';
import { Home, Users, Building2, FileText, Hammer, Wrench } from 'lucide-react';

const industries = [
    { icon: Home, label: 'Real Estate Agents' },
    { icon: Users, label: 'Team Leaders' },
    { icon: Building2, label: 'Mortgage Brokers' },
    { icon: FileText, label: 'Title & Escrow' },
    { icon: Hammer, label: 'Builders & Contractors' },
    { icon: Wrench, label: 'Home Service Professionals' },
];

export function IndustryGrid() {
    return (
        <section className="bg-white py-24 md:py-32" data-testid="industry-section">
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="text-center mb-12">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight mb-4">
                        Built for Real Estate. Works Across the Industry.
                    </h2>
                    <p className="text-[#6B7280] text-lg leading-relaxed max-w-2xl mx-auto">
                        We work with agents, team leaders, and the professionals who support them - mortgage brokers, title reps, builders, inspectors, electricians, and other relationship-based businesses. If your growth is limited by how much you personally can do, we built this for you.
                    </p>
                </motion.div>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                    {industries.map((item, i) => (
                        <motion.div
                            key={item.label}
                            {...staggeredFadeIn(i * 0.08)}
                            className="flex items-center gap-3 bg-[#F8F9FA] border border-gray-100 rounded-sm px-5 py-4 hover:shadow-md hover:border-gold-200 transition-all duration-300"
                            data-testid={`industry-card-${i}`}
                        >
                            <item.icon size={20} className="text-gold-400 flex-shrink-0" strokeWidth={1.5} />
                            <span className="font-inter font-semibold text-navy-900 text-sm">{item.label}</span>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
